// Utility function to get asset paths
export const getAssetPath = (path) => {
  const publicUrl = process.env.PUBLIC_URL || '';
  return `${publicUrl}${path}`;
};

